import React, { lazy } from 'react';

const LazyHeader = lazy(() => import('./Header'));

const Header = (props) => <LazyHeader {...props} />;

export default Header;
